export default __webpack_public_path__ + "static/media/나이너스.f309abf5.svg";